'use strict';

const $ = require('dibs-jquery-shim');
const actions = require('./pdpActionsConstants.es.js');
const itemQuery = require('../../global/headItemQuery.es');
const pdpTracking = require('../helpers/pdpTracking.es');
const { getShipmentPrequotes } = require('../components/Shipping/shippingHelpers.es');
const { getUserId, getBuyerToken, cookieJarConstants } = require('dibs-cookie-jar');
const { MASQUERADE_BUYER } = cookieJarConstants;
const get = require('lodash.get');

const pdpActions = {
    bootstrapPage: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_RECEIVE_PAGE, payload);
    },

    setIndex: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_CAROUSEL_INDEX, payload);
    },

    setHeroExpanded: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_HERO_EXPANDED, payload);
    },

    setShippingRequestAuthenticated: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_SHIPPING_REQUEST_AUTHENTICATED, payload);
    },

    setShippingRequestCompleted: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_SHIPPING_REQUEST_COMPLETED, payload);
    },

    setHeroChangingSize: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_HERO_CHANGING_SIZE, payload);
    },

    setPrintPage: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_PRINT_PAGE, payload);
    },

    /**
     *
     * @param actionContext
     * @param {object}  payload
     * @param {boolean} payload.showInfo - show/hide buyer assurance tooltip/modal on pdp
     */
    toggleBuyerAssuranceShowInfo: (actionContext, payload) => {
        actionContext.dispatch(actions.ACTION_TOGGLE_BUYER_ASSURANCE_SHOW_INFO, payload);
    },

    // FINDING-7016 : Pdp Buyer Assurance
    // to surface the new buyer assurance program, we need to show a highlighted border around the
    // Pdp Support Component...
    // todo: remove this after initial surfacing is done
    deleteBuyerAssurance: actionContext => {
        actionContext.dispatch(actions.ACTION_DELETE_BUYER_ASSURANCE_COOKIE);
    },

    asyncLoadItem: (actionContext, { pk }) => {
        const userId = getUserId(document.cookie, MASQUERADE_BUYER);
        const userToken = get(getBuyerToken(document.cookie), 'userToken', '');
        const hasUserId = !!userId;

        $.ajax({
            method: 'POST',
            url: '/soa/graphql/' + (userToken ? '?userToken=' + userToken : ''),
            data: {
                query: itemQuery.query(pk, userId, hasUserId),
            },
        })
            .done(data => {
                const item = get(data, 'data.viewer.item', {});
                const { domesticDeliveryOptions, localDeliveryOptions, shipmentQuotes } = get(
                    data,
                    'data.viewer',
                    {}
                );
                const quotes = getShipmentPrequotes({
                    localDeliveryOptions,
                    domesticDeliveryOptions,
                    shipmentQuotes,
                });
                const canRequestShippingQuote = get(
                    data,
                    'data.viewer.user.canRequestShippingQuote'
                )
                    ? 'y'
                    : 'n';

                actionContext.dispatch('ASYNC_LOAD_ITEM', { json: item });
                pdpTracking.trackShippingStatusData(quotes, canRequestShippingQuote);
            })
            .fail((jqXHR, textStatus) => {
                console.warn(
                    'Call failed or exceeded 500ms--defaulting to cached Item.\n',
                    new Error(textStatus)
                );
                actionContext.dispatch('ASYNC_LOAD_ITEM');
            });
    },

    setForceFavoriteItem: actionContext => {
        actionContext.dispatch(actions.ACTION_FORCE_FAVORITE_ITEM);
    },
};

module.exports = pdpActions;



// WEBPACK FOOTER //
// ./assets/js/newPdp/actions/PdpActions.es.js